<template>
  <div id="alert" class="Rectangle">
    <img class="alert-icon" :src="alert" />
    <p class="error-alert">{{ $t("errors." + errorMsg) }}</p>
  </div>
</template>

<script>
export default {
  name: "Alert",

  props: ["metamask", "errorMsg", "website", "browser"],
  created() {
    if (this.website) {
      var currentUrl = document.referrer;
      this.wallidURL =
        "https://wallid.io/" + "?returnURL=" + encodeURIComponent(currentUrl); //
    }
  },
  data() {
    return {
      alert: require("../assets/alert.svg"),
      wallidURL: "",
      chrome: "https://www.google.com/chrome/",
    };
  },
};
</script>

<style></style>
